import { FC } from 'react';
import './Input.scss';
import { IonItem, IonLabel, IonRow, IonTextarea } from '@ionic/react';
import { DqText } from '../dq-text';

// Note: uses styles from Input.scss

export interface TextareaProps {
  /*
   * The unique identifier of the input
   */
  id: string;
  /**
   * The name attribute of the input - used for formik form validation and submission
   */
  name?: string;
  /**
   * The id of the input
   */
  placeholder?: string;
  /**
   * The label to display above the text input
   */
  label?: string;
  /**
   * The error text to display
   */
  errorText?: string;
  /**
   * The value of the input
   */
  value?: string;
  /**
   * Whether or not the input is disabled
   */
  disabled?: boolean;
  /**
   * Whether or not the input is required
   */
  required?: boolean;
  /**;
   * The callback triggered when the input is changed
   */
  onChange?: (event: CustomEvent) => void;
  /**
   * The callback triggered when the input loses focus
   */
  onBlur?: (event: CustomEvent) => void;
}

export const Textarea: FC<TextareaProps> = ({
  id,
  label,
  required = false,
  value,
  placeholder,
  onChange,
  disabled = false,
  errorText,
  name,
  onBlur,
}) => {
  return (
    <>
      <IonRow className="custom-input-label-row">
        {label && (
          <IonLabel className="custom-input-label" mode="md">
            {label}
          </IonLabel>
        )}
        {required && (
          <div className="custom-input-required-label">
            <span className="red-asterisk"> *</span>
            <IonLabel className="custom-input-label" mode="md">
              Required
            </IonLabel>
          </div>
        )}
      </IonRow>
      <IonItem fill="outline" className={!errorText ? 'outlined-input-item' : 'outline-input-item-error'} mode="md">
        <IonTextarea
          id={id}
          mode="md"
          value={value}
          placeholder={placeholder}
          onIonChange={onChange}
          onIonBlur={onBlur}
          disabled={disabled}
          name={name}
        />
      </IonItem>
      {errorText && (
        <>
          <span className="red-asterisk"> *</span>
          <DqText>{errorText}</DqText>
        </>
      )}
    </>
  );
};
